import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Initialisation i18next
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'default',
    fallbackLng: 'default',
    ns: ['Decision', 'EditAction', 'Historic', 'Operation', 'Profile', 'Settings', 'UnderConstruction',
          'Map', 'Organizations', 'Qrcode',
          'Industrial', 'Partner', 'StoreManager', 'WarehouseManager', 'Reconditioning' ],
    defaultNS: 'Common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      queryStringParams: { v: Date.now() }
    },
    debug: false,
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
    cache: {
      enabled: false
    }
  });

export default i18n;